/* eslint-disable max-len */
import React, {FC} from "react"
import {withTheme, WithDefaultTheme} from "styled-components"

import BaseSvgIcon from "../Base"

interface Props extends WithDefaultTheme {}

const CircleTickFill: FC<Props> = ({theme, ...props}) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <defs>
        <polygon id="circle-tick-fill-a" points="0 0 6.715 0 6.715 6 0 6" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill={theme.colors.tertiary.g_400}
          fillRule="nonzero"
          d="M8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8 C15.9948137,3.58387202 12.416128,0.00518629776 8,0 Z"
        />
        <g transform="translate(5 5)">
          <mask id="circle-tick-fill-b" fill={theme.colors.utility.white}>
            <use xlinkHref="#circle-tick-fill-a" />
          </mask>
          <path
            fill={theme.colors.utility.white}
            d="M2.6436,5.99953 C2.5116,5.99953 2.3836,5.94653 2.2896,5.85353 L0.1466,3.71053 C-0.0484,3.51553 -0.0484,3.19853 0.1466,3.00353 C0.3416,2.80853 0.6586,2.80853 0.8536,3.00353 L2.5806,4.72853 L5.8076,0.20853 C5.9686,-0.01547 6.2796,-0.06647 6.5056,0.09253 C6.7306,0.25353 6.7826,0.56453 6.6226,0.79053 L3.0506,5.79053 C2.9646,5.90953 2.8306,5.98553 2.6846,5.99753 C2.6706,5.99853 2.6576,5.99953 2.6436,5.99953"
            mask="url(#circle-tick-fill-b)"
          />
        </g>
      </g>
    </BaseSvgIcon>
  )
}

export default withTheme(CircleTickFill)
